import { render, staticRenderFns } from "./covid19.vue?vue&type=template&id=fe65d5e8&"
import script from "./covid19.vue?vue&type=script&lang=js&"
export * from "./covid19.vue?vue&type=script&lang=js&"
import style0 from "./covid19.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports